import {Component, Inject, Input, LOCALE_ID, OnDestroy, OnInit} from '@angular/core';
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';
import {CustomerOverViewService} from '~features/customer-overview/customer-overview.service';
import {TablesTranslations} from '~shared/components/tables/tables-translations.service';
import {Customer, InvoiceOrderStatus, InvoiceTicketByYear} from '~core/models';
import {DefaultNotificationService, InvoiceService, TixxConnectionService} from '~core/services';
import {InvoiceOrderStatusTranslationsService} from '~shared/translations';
import {NotificationType} from "~core/enum";
import {HttpErrorResponse} from "@angular/common/http";


/**
 * Component class that displays the list of reservations
 */
@UntilDestroy()
@Component({
  selector: 'app-page-reservations-list',
  templateUrl: './page-reservations-list.component.html',
  styleUrls: ['../../../customer-overview.component.scss']
})
export class PageReservationsListComponent implements OnInit, OnDestroy {
  public loading: boolean = true;
  public invoiceList: Array<InvoiceTicketByYear> = [];
  public bookableReservations: number = 0;
  public invoiceClass: Array<any> = [];
  public invoiceOrderStatus: InvoiceOrderStatus;
  public i18nTixxReservationsTimeout = $localize`:@@notification.warning.tixxReservationTimeout:Tixx Reservations for this customer can't be displayed as there are too many. Please visit the customer profile in Tixx to see all reservations.`;
  public tixxReservationsTimedOut: boolean = false;

  public columns: Array<string> = [];
  public keys: Array<Array<string>> = [];

  @Input() public customer: Customer;

  constructor(
    public customerService: CustomerOverViewService,
    public invoiceOrderStatusTranslations: InvoiceOrderStatusTranslationsService,
    public tixxConnectionService: TixxConnectionService,
    public invoiceService: InvoiceService,
    public tablesTranslations: TablesTranslations,
    private notificationService: DefaultNotificationService,
    @Inject(LOCALE_ID) public locale: any
  ) {
    this.invoiceService.castReservationsListPage.pipe(untilDestroyed(this))
      .subscribe(data => this.invoiceList = data);
    this.invoiceOrderStatus = new InvoiceOrderStatus(this.invoiceOrderStatusTranslations);
    this.invoiceService.castNumberOfReservations.pipe(untilDestroyed(this)).subscribe(value => this.bookableReservations = value);

    this.columns.push(this.tablesTranslations.i18nDate, this.tablesTranslations.i18nReservationNr,
      this.tablesTranslations.i18nEventsAndTickets, this.tablesTranslations.i18nAmount, this.tablesTranslations.i18nStatus);
    this.keys.push(['date', 'reservationNumber', 'events', 'totalAmount', 'invoiceState'], ['', '', 'eventAndTicket', '', '']);
  }

  public ngOnInit(): void {
    this.invoiceService.getCustomerReservationsRaw(this.customer.id)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          let invoiceTicket: InvoiceTicketByYear;
          const newArray = [];
          const reservationTickets = {};
          res.forEach(invoice => {
            const date = new Date(invoice.orderDetails.invoiceDate);
            const year = date.getFullYear();
            (reservationTickets[year] || (reservationTickets[year] = [])).push(invoice);
          });
          Object.keys(reservationTickets).forEach(key => {
            invoiceTicket = new InvoiceTicketByYear(reservationTickets[key], key, this.invoiceOrderStatusTranslations);
            newArray.push(invoiceTicket);
          });
          newArray.sort((a, b) => a.year < b.year ? 1 : -1);
          this.loading = false;
          this.invoiceService.setReservationsListPage(newArray);
        },
        error: (error: HttpErrorResponse) => {
          this.loading = false;
          if (error.status === 504 || error.error['hydra:description'] === 'TIXX_API_TIMEOUT') {
            this.tixxReservationsTimedOut = true;
            this.notificationService.showNotification({
              type: NotificationType.WARNING,
              message: this.i18nTixxReservationsTimeout
            });
          }
        }
      });
  }

  public ngOnDestroy(): void {
  }

  /**
   * Selects the invoice and opens it in the sidepanel
   */
  public openInvoice(invoice: any): void {
    this.customerService.toggleAllModal(false);
    this.customerService.toggleInvoicesModal(true);
    this.invoiceService.setSelectedInvoice(invoice);
  }

}
